export default __webpack_public_path__ + "static/media/3.a8a2354f.jpg";